<template>
    <div>
        <vx-card title="Education" subtitle="Lists of Employee Education"  class="no-scroll-content" >


        <!-- <p>You can have a sebra effect by adding the property <code>stripe</code></p><br> -->
        <vs-button type="gradient" color="primary" @click="promptAddNewEducation()"  icon-pack="feather" icon="icon-plus">Add</vs-button>

        <div class="vx-col w-full mb-base">
            <template>
                <vs-table stripe v-model="selected"  search  :data="employeeEducation">
                    <template slot="thead">
                        <vs-th>Degree</vs-th>
                        <vs-th>Area Of Study</vs-th>
                        <vs-th>Institution</vs-th>
                        <vs-th>From Year</vs-th>
                        <vs-th>To Year</vs-th>
                        <vs-th>Award</vs-th>
                        <vs-th>Rank</vs-th>
                        <vs-th>Remarks</vs-th>
                        <vs-th>Action</vs-th>
                    </template>
                    <template slot-scope="{data}">
                        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                            <vs-td :data="data[indextr].degreeId">
                                {{ degreeName(data[indextr].degreeId).degreeName }}
                            </vs-td>
                            <vs-td :data="data[indextr].areaOfStudyId">
                                {{ areaOfStudyName(data[indextr].areaOfStudyId).areaOfStudyName}}
                            </vs-td>
                            <vs-td :data="data[indextr].institutionId">
                                {{ institutionName(data[indextr].institutionId).institutionName}}
                            </vs-td>
                            <vs-td :data="data[indextr].yearFrom">
                                {{data[indextr].yearFrom}}
                            </vs-td>
                            <vs-td :data="data[indextr].yearTo">
                                {{data[indextr].yearTo}}
                            </vs-td>
                            <vs-td :data="data[indextr].awardId">
                                {{awardName(data[indextr].awardId).awardName }}
                            </vs-td>
                            <vs-td :data="data[indextr].rankId">
                                {{rankName(data[indextr].rankId).rankName }}
                            </vs-td>
                            <vs-td :data="data[indextr].remarks">
                                {{data[indextr].remarks}}
                            </vs-td>
                            <vs-td>
                                <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
                                    <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="editRecord(data[indextr].id)" />
                                    <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="confirmDeleteRecord(data[indextr].id)" />
                                </div>
                            </vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
            </template>
             
        </div>

            <!-- ADD ACCREDITATION -->
            <vs-prompt
                class="email-compose"
                title="Education"
                accept-text= "Submit"
                @accept="onAddEducation"
                :is-valid="validForm"
                :active.sync="activePromptNewEducation">
                <vx-card title="Fill-out the following information">


                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Degree</span><span style="color:red">*</span>
                        <v-select name="degree-name" class="w-full" v-model="degree" label="degreeName" :options="getAllDegreeLookup" placeholder="Please Select" />

                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Area Of Study</span><span style="color:red">*</span>
                        <v-select name="areaOfStudy-name" class="w-full" v-model="areaOfStudy" label="areaOfStudyName" :options="getAllAreaOfStudyLookup" placeholder="Please Select" />

                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Institution</span><span style="color:red">*</span>
                         <v-select name="institution" class="w-full" v-model="institution" label="institutionName" :options="getAllInstitutionLookup" placeholder="Please Select"/>

                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-1/2 w-full mb-4">
                        <span  class="text-sm">From</span>
                        <v-select  name="year from" class="w-full" v-model="yearFrom" label="year" :options="getYearsLookup" placeholder="1900"/>
                        <!-- <span class="text-danger text-sm" v-show="errors.has('year from')">{{ errors.first('year from') }}</span> -->
                    </div>
                    <div class="vx-col sm:w-1/2 w-full mb-4">
                        <span  class="text-sm">To</span>
                        <v-select  name="year to" class="w-full" v-model="yearTo" label="year" :options="getYearsLookup" placeholder="1900" />
                        <!-- <span class="text-danger text-sm" v-show="errors.has('year to')">{{ errors.first('year to') }}</span> -->
                        
                    </div>
                </div>
                 <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Award</span>
                        <v-select name="award-name" v-model="award" label="awardName" :options="getAllAwardLookup" placeholder="Please Select"/>

                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Rank</span>
                        <v-select name="rank-name" v-model="rank" label="rankName" :options="getAllRankLookup" placeholder="Please Select" />

                    </div>
                </div>
                <div class="vx-row mb-2">
                    <div class="vx-col w-full mb-2">
                        <span class="text-sm">Remarks</span>
                        <vs-input name="remarks-name" class="w-full" v-model="remarks" placeholder="Remarks" />
                    </div>
                </div>


            
                </vx-card>
            </vs-prompt>




                 <!-- EDIT ACCREDITATION -->
            <vs-prompt
                class="email-compose"
                title="Education"
                accept-text= "Submit"
                @accept="onEditEducation"
                :is-valid="validForm"
                :active.sync="activePromptEditEducation">
                <vx-card title="Fill-out the following information">


                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Degree</span><span style="color:red">*</span>
                        <v-select name="degree-name" class="w-full" v-model="degree" label="degreeName" :options="getAllDegreeLookup" placeholder="Please Select" />

                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Area Of Study</span><span style="color:red">*</span>
                        <v-select name="areaOfStudy-name" class="w-full" v-model="areaOfStudy" label="areaOfStudyName" :options="getAllAreaOfStudyLookup" placeholder="Please Select" />

                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Institution</span><span style="color:red">*</span>
                         <v-select name="institution" class="w-full" v-model="institution" label="institutionName" :options="getAllInstitutionLookup" placeholder="Please Select"/>

                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-1/2 w-full mb-4">
                        <span  class="text-sm">From</span>
                        <v-select  name="year from" class="w-full" v-model="yearFrom" label="year" :options="getYearsLookup" placeholder="1900"/>
                        <!-- <span class="text-danger text-sm" v-show="errors.has('year from')">{{ errors.first('year from') }}</span> -->
                    </div>
                    <div class="vx-col sm:w-1/2 w-full mb-4">
                        <span  class="text-sm">To</span>
                        <v-select  name="year to" class="w-full" v-model="yearTo" label="year" :options="getYearsLookup" placeholder="1900" />
                        <!-- <span class="text-danger text-sm" v-show="errors.has('year to')">{{ errors.first('year to') }}</span> -->
                        
                    </div>
                </div>
                 <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Award</span>
                        <v-select name="award-name" v-model="award" label="awardName" :options="getAllAwardLookup" placeholder="Please Select"/>

                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Rank</span>
                        <v-select name="rank-name" v-model="rank" label="rankName" :options="getAllRankLookup" placeholder="Please Select" />

                    </div>
                </div>
                <div class="vx-row mb-2">
                    <div class="vx-col w-full mb-2">
                        <span class="text-sm">Remarks</span>
                        <vs-input name="remarks-name" class="w-full" v-model="remarks" placeholder="Remarks" />
                    </div>
                </div>



            
                </vx-card>
            </vs-prompt>
        </vx-card>
    </div>
</template>
<script>
import Datepicker from 'vuejs-datepicker'
import { en, he } from 'vuejs-datepicker/src/locale'

import moment from 'moment'
import vSelect from 'vue-select'

import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

export default {
    data() {
        return {
            selected            : [],
            id                  : 0,
            degree              : [],
            birthdate           : null,
            areaOfStudy         : [],
            institution         : [],
            yearTo              : '',
            yearFrom            : '',
            award               : [],
            rank                : [],
            acquintanceHistory  : '',
            remarks             : '',
            userId              : null,

            uid                 : null,
            activePromptNewEducation    : false,
            activePromptEditEducation    : false,

            format: "d MMMM yyyy",
        }
    },
    created() {
            this.$vs.loading()
            // this.$store.dispatch('hrms/getAllEducation', { userId : null})
            this.$store.dispatch('lookup/getAllDegreeLookup').catch((err) => { console.log(err) })
            this.$store.dispatch('lookup/getAllAreaOfStudyLookup').catch((err) => { console.log(err) })
            this.$store.dispatch('lookup/getAllInstitutionLookup').catch((err) => { console.log(err) })
            this.$store.dispatch('lookup/getAllAwardLookup').catch((err) => { console.log(err) })
            this.$store.dispatch('lookup/getAllRankLookup')
                .then(res => { this.$vs.loading.close() })
                .catch(error => { 
                        this.$vs.loading.close()
                        this.$vs.notify({
                        title: 'Error',
                        text: error.message,
                        iconPack: 'feather',
                        icon: 'icon-x-octagon',
                        color: 'danger'
                        })
                })
            this.award.awardId = 1
            this.rank.rankId = 1
            this.uid = this.$route.params.id
            this.employeeEducation = this.uid
            //  this.$store.dispatch('hrms/getAllEducation',  this.uid )
            
    },
    computed: {
        employeeEducation: {
           
           get() { return this.$store.state.hrms.employeeEducation },
           set(value) { this.$store.dispatch('hrms/getAllEducation',  value )}
            
        },
        validForm(){
            return this.degree.degreeId != null &&
            this.institution.institutionId != null &&
            this.areaOfStudy.areaOfStudyId !=null

            
        },
        getYearsLookup () {
            const year = new Date().getFullYear()
            return Array.from({length: year - 1900}, (value, index) => 1901 + index)
        },
        getAllRankLookup() {
            return this.$store.state.lookup.getAllRankLookup
        },
        getAllDegreeLookup() {
             return this.$store.state.lookup.getAllDegreeLookup
        },
        getAllInstitutionLookup() {
             return this.$store.state.lookup.getAllInstitutionLookup
        },
        getAllAreaOfStudyLookup() {
             return this.$store.state.lookup.getAllAreaOfStudyLookup
        },
        getAllAwardLookup() {
             return this.$store.state.lookup.getAllAwardLookup
        },
        degreeName() {
            return (id) => this.$store.getters['lookup/degreeLookup'](id)
        },
        areaOfStudyName() {
            return (id) => this.$store.getters['lookup/areaOfStudyLookup'](id)
        },
        institutionName() {
            return (id) => this.$store.getters['lookup/institutionLookup'](id)
        },
        awardName() {
            return (id) => this.$store.getters['lookup/awardLookup'](id)
        },
        rankName() {
            return (id) => this.$store.getters['lookup/rankLookup'](id)
        },
    },
    methods: {
        promptAddNewEducation() {
            this.activePromptNewEducation = true
        },
        onAddEducation() {
            this.$validator.validateAll().then(result => {
            if (result) {
                    this.$vs.loading()

                    const data = {
                        degreeId            : this.degree.degreeId,
                        areaOfStudyId       : this.areaOfStudy.areaOfStudyId,
                        institutionId       : this.institution.institutionId,
                        yearFrom            : this.yearFrom,
                        yearTo              : this.yearTo,
                        awardId             : this.award.awardId,
                        rankId              : this.rank.rankId,
                        remarks             : this.remarks,
                        userId              : this.uid,
                        currentUserId       : this.$store.state.AppActiveUser.uid
                    }

                    this.$store.dispatch('hrms/AddEducation', data)
                    .then((response) =>{
                            this.$vs.loading.close()
                            this.$vs.notify({
                            title: 'Success',
                            text: 'Accredition Saved',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'success'                  
                            })
                    })
                    .catch(error => {
                            this.$vs.loading.close()
                            this.$vs.notify({
                            title: 'Error',
                            text: error.message,
                            iconPack: 'feather',
                            icon: 'icon-x-octagon',
                            color: 'danger'
                        })
                    })
                } else {
                    // form have errors
                    this.$vs.notify({
                        title: 'Error',
                        text: error.message,
                        iconPack: 'feather',
                        icon: 'icon-x-octagon',
                        color: 'danger'
                    })
                }
                })
        },
        onEditEducation() {
            this.$validator.validateAll().then(result => {
            if (result) {
                const data = {
                    id                  : this.id,
                    degreeId            : this.degree.degreeId,
                    areaOfStudyId       : this.areaOfStudy.areaOfStudyId,
                    institutionId       : this.institution.institutionId,
                    yearFrom            : this.yearFrom,
                    yearTo              : this.yearTo,
                    awardId             : this.award.awardId,
                    rankId              : this.rank.rankId,
                    remarks             : this.remarks,
                    userId              : this.uid,
                    currentUserId       : this.$store.state.AppActiveUser.uid
                }
                this.$store.dispatch('hrms/UpdateEducation', data)
                    .then(response => {
                            this.$vs.loading.close()
                            this.$vs.notify({
                            title: 'Success',
                            text: 'Education Updated',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'success'                  
                            })
                    })
                    .catch(error => {
                            this.$vs.loading.close()
                            this.$vs.notify({
                            title: 'Error',
                            text: error.message,
                            iconPack: 'feather',
                            icon: 'icon-x-octagon',
                            color: 'danger'
                        })
                    })
                } else {
                // form have errors
                this.$vs.notify({
                            title: 'Error',
                            text: error.message,
                            iconPack: 'feather',
                            icon: 'icon-x-octagon',
                            color: 'danger'
                        })
            }
            })
        },
        editRecord(Id) {

            const e = this.$store.getters['hrms/employeeEducation'](Id)
            this.id                  = e.id,
            this.degree              = this.degreeName(e.degreeId),
            this.areaOfStudy         = this.areaOfStudyName(e.areaOfStudyId),
            this.institution         = this.institutionName(e.institutionId),
            this.yearFrom            = e.yearFrom,
            this.yearTo              = e.yearTo,
            this.award               = this.awardName(e.awardId),
            this.rank                = this.rankName(e.rankId),
            this.remarks             = e.remarks
            this.userId              = e.userId

            this.activePromptEditEducation = true
        },
        confirmDeleteRecord(id) {
            this.$store.dispatch('hrms/DeleteEducation', id)
            .then(res => {
                this.$vs.loading.close()
                        this.employeeEducation = this.uid
                        this.$vs.notify({
                        title: 'Success',
                        text: 'Education Deleted',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'success'                  
                        })
                   })
                .catch(error => {
                        this.$vs.loading.close()
                        this.$vs.notify({
                        title: 'Error',
                        text: error.message,
                        iconPack: 'feather',
                        icon: 'icon-x-octagon',
                        color: 'danger'
                    })
                })
        }
    },
    components: {
        'v-select': vSelect,
        Datepicker,
        flatPickr,
        // VuePerfectScrollbar,
    },
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/email.scss";
@import "@/assets/scss/vuexy/apps/simple-calendar.scss";
</style>